



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { IEmployeeSearchResult } from '@/models/EmployeeModels';

import Api from '@/Api';

@Component
export default class SearchBar extends Vue {
    public items: any = [];
    public item: any = null;
    public search: any = null;

    public onSelect(event: any) {
        if (!event) {
            return;
        }
        this.$router.push({name: 'profile', params: {id: event}});
    }

    @Watch('search') public onSearch(val: any) {
        Api.Instance
            .get(`/api/search?q=${val}`)
            .then((response) => {
                this.items = response.data;
            });
    }
}
